import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';
import { getResponseStatus } from '@app/services/apiErrors';

export const useEpdSigningCountQuery = (enabled: boolean) =>
  useQuery({
    queryKey: ['epd', 'count'],
    queryFn: () => Api.orders.getEpdSigningCount(),
    enabled,
    refetchInterval: (_, query) => (!enabled || getResponseStatus(query.state.error) === 403 ? false : 30000),
  });
